import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=70add9b1&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70add9b1')) {
      api.createRecord('70add9b1', component.options)
    } else {
      api.reload('70add9b1', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=70add9b1&", function () {
      api.rerender('70add9b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vzRA5j2DJZI3/JS/comp/childrenage.vue"
export default component.exports